import script from "./AutoCollapse.vue?vue&type=script&setup=true&lang=ts"
export * from "./AutoCollapse.vue?vue&type=script&setup=true&lang=ts"

import "./AutoCollapse.vue?vue&type=style&index=0&id=53e26025&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53e26025"]])

export default __exports__